import { useContext } from 'react';
import { CookieConsentContext } from './cookieConsentContextShared';

export function useCookieConsent() {
  const ctx = useContext(CookieConsentContext);
  if (ctx === undefined) {
    throw new Error('useCookieConsent must be used within CookieConsentProvider');
  }
  return ctx;
}
